export default function dlFontUrl(font) {
  return URLS.API+'fonts/dl/'+font;
}



// WEBPACK FOOTER //
// ./src/lib/admin/dlFontUrl.js